export type GiroPreset = { id: string; name: string; color: string };
export const GIRO_PRESETS: GiroPreset[] = [
  { id: "default", name: "General", color: "#ff6b00" },
  { id: "tech", name: "Tecnología", color: "#2563eb" },
  { id: "food", name: "Alimentos", color: "#16a34a" }
];
